<template>
  <div>
    <h4 class="title">Documentos</h4>
    <v-list subheader class="documents-list">
      <v-list-item-group>
        <template v-for="(file, index) in documentos">
          <v-list-item
            :key="file.id"
            :dense="true"
            :selectable="false"
            class="documents-list__item"
          >
            <v-list-item-avatar @click.prevent.stop="doDownload(file)">
              <v-icon class="red darken-2" dark style="color: #fff !important">
                {{ documentsAceptedImg.includes(file.tipoDocumento) ? 'image' : 'picture_as_pdf' }}
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="mt-3">
                {{
                  typeSolicitation === 'RENOVACAO_CADASTRO_TRANSPORTADORA' &&
                  file.tipoDocumento === 'REQUERIMENTO_TRANSPORTADORA_ASSINADO'
                    ? 'Requerimento ou apresentar contrato social se sociedade comercial EPP, ou no caso de sociedade por ações  ME'
                    : tipoDocumento[file.tipoDocumento]
                }}
              </v-list-item-title>

              <v-list-item-subtitle v-text="`Arquivo: ${file.nomeArquivo}`" />

              <!-- COPIA_CRLV -->
              <v-list-item-subtitle
                v-if="file.tipoDocumento === 'COPIA_CRLV'"
                v-text="`Renavam: ${file.numeroComplemento}`"
              />
              <v-list-item-subtitle
                v-if="['COPIA_CRLV'].includes(file.tipoDocumento)"
                v-text="`Data Emissão: ${file.dataEmissao}`"
              />
              <v-list-item-subtitle
                v-if="file.tipoDocumento === 'COPIA_CRLV'"
                v-text="`Data Validade (Licenciamento): ${file.dataValidade}`"
              />
              <!--/ COPIA_CRLV -->

              <!-- APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA -->
              <v-list-item-subtitle
                v-if="file.tipoDocumento === 'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA'"
                v-text="`Seguradora: ${file.orgaoExpedidor}`"
              />
              <v-list-item-subtitle
                v-if="file.tipoDocumento === 'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA'"
                v-text="`Número Apólice: ${file.numeroComplemento}`"
              />
              <v-list-item-subtitle
                v-if="
                  [
                    'CERTIDAO_NEGATIVA_FALENCIA',
                    'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA',
                    'BALANCO_PATRIMONIAL',
                    'APOLICE_SEGURO_RESPONSABILIDADE_CIVIL',
                    ,
                  ].includes(file.tipoDocumento)
                "
                v-text="`Data Emissão: ${file.dataEmissao}`"
              />
              <v-list-item-subtitle
                v-if="
                  [
                    'CERTIDAO_NEGATIVA_FALENCIA',
                    'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA',
                    'BALANCO_PATRIMONIAL',
                    'APOLICE_SEGURO_RESPONSABILIDADE_CIVIL',
                    ,
                  ].includes(file.tipoDocumento)
                "
                v-text="`Data Validade: ${file.dataValidade}`"
              />
              <!--/ APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA -->

              <!-- LAUDO_TECNICO -->
              <v-list-item-subtitle
                v-if="
                  [
                    'CERTIDAO_NEGATIVA_FALENCIA',
                    'LAUDO_TECNICO',
                    'BALANCO_PATRIMONIAL',
                    'APOLICE_SEGURO_RESPONSABILIDADE_CIVIL',
                    ,
                  ].includes(file.tipoDocumento)
                "
                v-text="`Profissional/Empresa Responsável: ${file.orgaoExpedidor}`"
              />
              <v-list-item-subtitle
                v-if="file.tipoDocumento === 'LAUDO_TECNICO'"
                v-text="`Número da ART: ${file.numeroComplemento}`"
              />
              <v-list-item-subtitle
                v-if="file.tipoDocumento === 'LAUDO_TECNICO'"
                v-text="`Data Emissão: ${file.dataEmissao}`"
              />
              <!--/ LAUDO_TECNICO -->

              <!-- ART -->
              <v-list-item-subtitle
                v-if="file.tipoDocumento === 'ART'"
                v-text="`Número da ART: ${file.numeroComplemento}`"
              />
              <v-list-item-subtitle
                v-if="file.tipoDocumento === 'ART'"
                v-text="`Data Emissão: ${file.dataEmissao}`"
              />
              <v-list-item-subtitle
                v-if="file.tipoDocumento === 'CERTIDAO_REGULAR_DA_ARCE'"
                v-text="`Código Validador: ${file.numeroComplemento}`"
              />
              <!--/ ART -->

              <!-- <v-list-item-subtitle>
                <span class="mr-2">Data Validade: {{file.dataValidade}} -</span>
                <span class="mr-2">Orgão Expedidor: {{file.orgaoExpedidor}} -</span>
                <span class="mr-2">Número/Complemento: {{file.numeroComplemento}}</span>
              </v-list-item-subtitle>-->

              <v-list-item-subtitle>
                <v-chip v-if="file.status === 'NAO_AVALIADO'" small class="mt-1 mb-1">
                  {{ statusAnexos[file.status] }}
                </v-chip>
                <v-chip
                  v-else
                  small
                  class="mt-1 mb-1"
                  :color="file.status === 'ACEITO' ? 'success' : 'error'"
                >
                  {{ statusAnexos[file.status] }}
                </v-chip>
                <v-chip
                  small
                  class="mt-1 mb-1 ml-3"
                  color="primary"
                  @click.prevent.stop="doDownload(file)"
                >
                  <v-icon size="15"> file_download </v-icon>Baixar
                </v-chip>
                <v-chip
                  v-if="
                    detail.data.status !== 'CANCELADO' &&
                    (file.status === 'REJEITADO' || file.status === 'NAO_AVALIADO')
                  "
                  small
                  class="mt-1 mb-1 ml-3"
                  color="success"
                  @click.prevent.stop="openDialogUpload(file)"
                >
                  <v-icon size="15"> edit </v-icon> Arquivo
                </v-chip>
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="file.status === 'REJEITADO'">
                Motivo Rejeição:
                {{ file.motivoRejeicao }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider :key="file.nomeArquivo + index" class="divider-item-list" />
        </template>
      </v-list-item-group>
    </v-list>

    <v-dialog v-if="dialogUpload.open" v-model="dialogUpload.open" width="500">
      <v-form ref="form" lazy-validation class="app-form" @submit.prevent="doUploadDocumento">
        <v-card class="mb-0">
          <v-card-title class="app-card-title"> Upload Documento </v-card-title>
          <v-card-text class="app-card-content">
            <v-text-field
              v-if="
                // dialogUpload.documento.tipoDocumento == 'ART' ||
                // dialogUpload.documento.tipoDocumento == 'LAUDO_TECNICO' ||
                // dialogUpload.documento.tipoDocumento == 'COPIA_CRLV' ||
                // dialogUpload.documento.tipoDocumento ==
                //   'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA'
                [
                  'ART',
                  'LAUDO_TECNICO',
                  'COPIA_CRLV',
                  'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA',
                  'CERTIDAO_NEGATIVA_FALENCIA',
                  'BALANCO_PATRIMONIAL',
                  'APOLICE_SEGURO_RESPONSABILIDADE_CIVIL',
                ].includes(dialogUpload.documento.tipoDocumento)
              "
              v-model="dialogUpload.dataEmissao"
              v-mask="'##/##/####'"
              outlined
              label="Data Emissão *"
              placeholder="Ex:. 13/03/2020"
              :rules="[
                rules.required,
                rules.date,
                rules.datePast,
                rules.dateFuture,
                rules.datePast,
              ]"
              dense
            />
            <v-text-field
              v-if="
                // dialogUpload.documento.tipoDocumento == 'COPIA_CRLV' ||
                // dialogUpload.documento.tipoDocumento ==
                //   'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA'

                [
                  'COPIA_CRLV',
                  'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA',
                  'CERTIDAO_NEGATIVA_FALENCIA',
                  'BALANCO_PATRIMONIAL',
                  'APOLICE_SEGURO_RESPONSABILIDADE_CIVIL',
                ].includes(dialogUpload.documento.tipoDocumento)
              "
              v-model="dialogUpload.dataValidade"
              v-mask="'##/##/####'"
              outlined
              :label="`Data Validade ${
                dialogUpload.documento.tipoDocumento === 'COPIA_CRLV' ? '(Licenciamento)' : ''
              } *`"
              placeholder="Ex:. 13/03/2020"
              :rules="[rules.required, rules.date, rules.datePast, rules.datePast]"
              dense
            />
            <v-text-field
              v-if="
                [
                  'CERTIDAO_NEGATIVA_FALENCIA',
                  'BALANCO_PATRIMONIAL',
                  'APOLICE_SEGURO_RESPONSABILIDADE_CIVIL',
                  'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA',
                  'LAUDO_TECNICO',
                ].includes(dialogUpload.documento.tipoDocumento)
              "
              v-model="dialogUpload.orgaoExpedidor"
              outlined
              :label="
                ['APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA'].includes(
                  dialogUpload.documento.tipoDocumento
                )
                  ? 'Seguradora *'
                  : 'Profissional/Empresa Responsável *'
              "
              :rules="[rules.required]"
              dense
            >
            </v-text-field>
            <v-text-field
              v-if="
                [
                  'CERTIDAO_REGULAR_DA_ARCE',
                  'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA',
                  'COPIA_CRLV',
                  'LAUDO_TECNICO',
                  'ART',
                ].includes(dialogUpload.documento.tipoDocumento)
              "
              v-model="dialogUpload.numeroComplemento"
              outlined
              :label="selectLabel(dialogUpload.documento.tipoDocumento)"
              :rules="[rules.required]"
              dense
            >
            </v-text-field>
            <Upload
              v-model="dialogUpload.file"
              :name-input="9999"
              @change="addDocument"
              :acceptImg="documentsAceptedImg.includes(dialogUpload.documento.tipoDocumento)"
            />
            <v-list v-if="dialogUpload.documento.file" subheader two-line>
              <v-list-item :key="`list-documents`" :dense="true" :selectable="true">
                <v-list-item-avatar>
                  <v-icon class="red darken-2" dark style="color: #fff !important">
                    picture_as_pdf
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="dialogUpload.documento.filename" />
                  <v-list-item-subtitle
                    v-text="
                      `Tipo: ${dialogUpload.documento.type} Tamanho: ${fileSize(
                        dialogUpload.documento.size
                      )}`
                    "
                  />
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <section v-if="dialogUpload.isLoading" class="loading">
              <v-progress-circular indeterminate color="success" />
              <span>Enviando informações ...</span>
            </section>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn outlined color="error" @click="closeDialogUpload"> Fechar </v-btn>
            <v-btn depressed color="success" type="submit" :disabled="!verifyCampos(dialogUpload)">
              Enviar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { StatusDocumentoEnum } from '@/models/sit-pedido/status-documento.enum';
import { TipoDocumento } from '@/models/sit-pedido/tipo-documento.enum';
import dayjs from 'dayjs';
import Upload from './Upload';

import { fileSize } from '@/util/format-file';

import { mapActions, mapState } from 'vuex';

import GlobalStore from '@/store/modules/global';
import pedidoService from '../../../../../services/sit-pedidos/pedido.service';
import { TipoDocumentoEnum } from '@/store/modules/renovacao-crlv';

// Vuex Store - Sit Pedidos (mapping actions and states)
const actions = mapActions('sitPedidos', ['upload', 'setDetailIsLoading']);
const state = mapState('sitPedidos', ['detail']);

export default {
  name: 'DocumentsList',
  components: {
    Upload,
  },
  props: {
    documentos: {
      type: Array,
      required: true,
    },
    typeSolicitation: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    statusAnexos: StatusDocumentoEnum,
    tipoDocumento: TipoDocumento,
    dialogUpload: {
      open: false,
      documento: null,
      file: null,
      isLoading: false,
    },
    rules: {
      required: value => !!value || 'Esse campo deve ser preenchido',

      date: function (value) {
        return !!dayjs(value, 'DD/MM/YYYY', true).isValid() || 'Data inválida';
      },

      dateFuture: function (value) {
        return !dayjs(value, 'DD/MM/YYYY', true).isAfter(dayjs()) || 'Data está no futuro';
      },

      datePast: function (value) {
        const datePastLimit = dayjs().subtract(100, 'year');
        return !dayjs(value, 'DD/MM/YYYY', true).isBefore(datePastLimit) || 'Data muito antiga';
      },

      // lessThanIssuanceDate: function(value) {
      //   return !dayjs(value, 'DD/MM/YYYY', true).isBefore(dayjs()) || "Data é menor que a data de emissão"
      // },
    },
    label: {
      CERTIDAO_REGULAR_DA_ARCE: 'Código Validador *',
      APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA: 'Número Apólice *',
      COPIA_CRLV: 'Renavam *',
      LAUDO_TECNICO: 'Número da ART *',
      ART: 'Número da ART *',
    },
    documentsAceptedImg: [
      TipoDocumentoEnum.FOTO_DA_FRENTE_DO_VEICULO,
      TipoDocumentoEnum.FOTO_DA_TRASEIRA_DO_VEICULO,
      TipoDocumentoEnum.FOTO_LATERAL_REFERENTE_AO_LADO_DO_MOTORISTA,
      TipoDocumentoEnum.FOTO_LATERAL_REFERENTE_AO_LADO_DE_ENTRADA_DOS_PASSAGEIROS,
      TipoDocumentoEnum.FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_PRIMEIRAS_POLTRONAS,
      TipoDocumentoEnum.FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_ULTIMAS_POLTRONAS,
      TipoDocumentoEnum.FOTO_CHASSI,
    ],
  }),
  computed: {
    ...state,
  },
  methods: {
    ...actions,
    addDocument() {
      const doc = this.dialogUpload.file;
      const {
        tipoDocumento,
        orgaoExpedidor,
        numeroComplemento,
        // dataEmissao,
        // dataValidade,
      } = this.dialogUpload.documento;
      const document = {
        nomeArquivo: doc.name,
        tipoDocumento,
        // dataEmissao,
        // dataValidade,
        orgaoExpedidor,
        numeroComplemento,
        file: doc,
        filename: doc.name,
        type: doc.type,
        size: doc.size,
        error: false,
        progress: 0,
        uploaded: false,
      };
      this.dialogUpload.documento = document;
    },
    fileSize(v) {
      return fileSize(v);
    },
    doDownload(item) {
      const { id, nomeArquivo } = item;
      const body = { id, nomeArquivo };
      this.download(body);
    },
    // TODO: mover para store actions
    download(value) {
      this.setDetailIsLoading(true);
      pedidoService.download(value).subscribe(
        res => {
          pedidoService.doDownloadFile(res, value.nomeArquivo);
          this.setDetailIsLoading(false);
        },
        error => {
          this.setDetailIsLoading(false);
        }
      );
    },
    openDialogUpload(item) {
      this.dialogUpload.open = true;
      this.dialogUpload.documento = item;
    },
    closeDialogUpload() {
      this.dialogUpload = {
        open: false,
        documento: null,
        file: null,
        isLoading: false,
      };
    },
    async doUploadDocumento() {
      this.dialogUpload.isLoading = true;
      const { dataEmissao, dataValidade, orgaoExpedidor, numeroComplemento } = this.dialogUpload;
      this.dialogUpload.documento.dataEmissao = dataEmissao || '';
      this.dialogUpload.documento.dataValidade = dataValidade || '';
      this.dialogUpload.documento.orgaoExpedidor = orgaoExpedidor || '';
      this.dialogUpload.documento.numeroComplemento = numeroComplemento || '';

      try {
        const {
          data: { id },
        } = this.detail;
        const { documento } = this.dialogUpload;
        await this.upload({ idPedido: id, doc: documento });
        this.closeDialogUpload();
        this.$emit('uploaded', true);
      } catch (error) {
        const errorBody = error.response;
        const message = errorBody.data.message ? errorBody.data.message : errorBody.data.error;
        GlobalStore.setSnackBar({
          show: true,
          message,
          type: 'error',
          timeout: 4000,
        });
        this.dialogUpload.isLoading = false;
      }
    },
    filterCampos() {
      tipoDocumento == 'ART' ||
        tipoDocumento == 'LAUDO_TECNICO' ||
        tipoDocumento == 'COPIA_CRLV' ||
        tipoDocumento == 'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA';
    },
    verifyCampos(val) {
      const {
        documento: { tipoDocumento },
      } = val;
      if (tipoDocumento == 'ART' || tipoDocumento == 'LAUDO_TECNICO')
        return val.file && val.dataEmissao;
      if (
        tipoDocumento == 'COPIA_CRLV' ||
        tipoDocumento == 'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA'
      )
        return val.file && val.dataEmissao && val.dataValidade;
      if (tipoDocumento == 'REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA') return val.file;
      if (tipoDocumento == 'COMPROVANTE_PAGAMENTO_TAXA_INCLUSAO') return val.file;
      if (tipoDocumento == 'CONTRATO_SOCIAL_ARRENDAMENTO_MERCANTIL') return val.file;
      if (
        [
          'CERTIDAO_NEGATIVA_FALENCIA',
          'BALANCO_PATRIMONIAL',
          'APOLICE_SEGURO_RESPONSABILIDADE_CIVIL',
        ].includes(tipoDocumento)
      )
        return val.file && val.dataEmissao && val.dataValidade && val.orgaoExpedidor;
      if (tipoDocumento == 'CERTIDAO_REGULAR_DA_ARCE') return val.file && val.numeroComplemento;
      if (
        [
          'REQUERIMENTO_TRANSPORTADORA_ASSINADO',
          'CERTIFICADO_CURSO_CAPACITACAO_OBRIGATORIO',
          'CERTIDAO_HISTORICO_INFRACOES',
          'CERTIDAO_NEGATIVA_DEBITOS_DETRAN_CE',
          'CERTIDAO_NEGATIVA_ANT_CRIM_FED_COMUM',
          'CERTIDAO_NEGATIVA_ANT_CRIMINAIS_ELEITORAL',
          'CERTIDAO_NEGATIVA_ANT_CRIMINAIS_COMUM',
          'CERTIDAO_NEGATIVA_ANT_CRIMINAIS_MILITAR',
          'CERTIDAO_NEGATIVA_ANT_CRIM_FED_MILITAR',
          'COPIA_CNH_CATEGORIA_D_OU_E',
          'CERTIDAO_NEGATIVA_ANT_CRIM_POLICIA_CIVIL',
          'COMPROVANTE_SERVICO_MILITAR',
          'CARTEIRA_RESERVISTA',
          'CERTIDAO_NEGATIVA_FEDERAL',
          'CERTIDAO_NEGATIVA_ESTADUAL',
          'CERTIDAO_NEGATIVA_MUNICIPAL',
          'CERTIDAO_NEGATIVA_ANT_CRIM_POLICIA_FEDERAL',
          'CPF',
          'RG',
          'CERTIDAO_NEGATIVA_ARCE',
          'CERTIDAO_INEXISTENCIA_DEBITO',
        ].includes(tipoDocumento)
      )
        return val.file;
      if (this.documentsAceptedImg.includes(tipoDocumento)) return val.file;
    },
    selectLabel(tipoDocumento) {
      return this.label[this.dialogUpload.documento.tipoDocumento] || 'Código validador *';
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold !important;
  border-bottom: solid 1px #c5c5c5;
  margin-bottom: 20px;
  margin-top: 0px;
  padding-bottom: 5px;
}
.divider-item-list {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.documents-list {
  padding-bottom: 12px;
}

.documents-list__item {
  align-items: flex-start;
}

.documents-list__item:last-of-type {
  padding-bottom: 12px;
}

::v-deep .documents-list__item .v-list-item__content {
  overflow: visible;
}

::v-deep .documents-list__item .v-list-item__title,
::v-deep .documents-list__item .v-list-item__subtitle {
  white-space: normal;
  overflow: visible;
  text-overflow: initial;
}
</style>
